export const POD_HEALTH_ISSUES = {
  WPL01: 'Offline or switched off',
  WPL02: 'Connection could be improved',
  WPL03: 'Connection could be improved',
  WPL04: 'You need to send this WiFi Pod back to us',
  WPL05: 'Connected and working',
};

export const WHITE_PODS = [3098075, 3098076, 3098077, 3098078, 3098079, 3098080];
export const BLACK_PODS = [3098081];
